import formatCurrency from 'utils/formatCurrency';
import { Col, Container, Row, Table } from 'reactstrap';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import { useEffect, useState } from 'react';
import { iPropostaDados } from 'views/pages/Proposta/components/Precificacao';
import api from 'services/api';
import { PropostaMeioPagamento } from 'models/PropostaMeioPagamento';
import { Label, Td, Th, CondicaoPagamentoRecursoRow } from './style';

export default function ImpressaoPagamento({
  propostaVersaoId,
  mostrarPercentual,
}: {
  propostaVersaoId: number;
  mostrarPercentual: boolean;
}): JSX.Element {
  const [informacaoProposta, setInformacaoProposta] =
    useState<iPropostaDados>();

  const [meioPagamentos, setMeioPagamentos] = useState<PropostaMeioPagamento[]>(
    [],
  );

  const isParalelo = false;
  const recursoProprio = 0;
  const percentualFinanciado = 0;
  const percentualParalelo = 0;
  const totalPercentual = 0;

  /*

  const valorTotal =
    parcelas.reduce(
      // eslint-disable-next-line prettier/prettier
    (total, item) => total + ((item?.valor ?? 0) * 100),
      0,
    ) / 100;

  const totalPercentualV =
    parcelas.reduce(
      // eslint-disable-next-line prettier/prettier
    (total, item) => total + ((item.valor ?? 0) * 100),
      0,
    ) / 100;

  const financiamento =
    parcelas
      .filter((item: any) => item.meioPagamentoId === 2)
      .reduce((accumulator, object) => {
        // eslint-disable-next-line prettier/prettier
      return accumulator + ((object.valor ?? 0) * 100);
      }, 0) / 100;

  const recursoProprioV =
    parcelas
      .filter((item: any) => item.meioPagamentoId === 1)
      .reduce((accumulator, object) => {
        // eslint-disable-next-line prettier/prettier
      return accumulator + ((object.valor ?? 0) * 100);
      }, 0) / 100;

  const recursoProprio = (recursoProprioV / valorTotal) * 100;
  const percentualFinanciado = (financiamento / valorTotal) * 100;
  const totalPercentual = (totalPercentualV / valorTotal) * 100;
  const percentualParalelo = percentualFinanciado + recursoProprio;
  */

  async function dadosProposta() {
    const response = await api.get(
      `/proposta-precificacao/versao/${propostaVersaoId}`,
    );

    const proposta = response.data as iPropostaDados;

    setInformacaoProposta(proposta);
  }

  async function dadosMeioPagamento() {
    const response = await api.get(`/proposta/meio-pagamento`);
    setMeioPagamentos(response.data as PropostaMeioPagamento[]);
  }

  useEffect(() => {
    dadosProposta();
    dadosMeioPagamento();
  }, []);

  function formataValor(valor?: number | null) {
    if (!informacaoProposta) return 0;

    const isPropostaExterior = informacaoProposta.isExterior;
    const valorDolar = informacaoProposta.valores.valorDolar ?? 0;

    if (!valor && !valorDolar) return formatCurrency(0, 2, isPropostaExterior);

    if (isPropostaExterior) {
      if (!valorDolar) return formatCurrency(0, 2, true);

      // Converte para Dólar
      const convertido = Number(valor ?? 0) / valorDolar;
      return formatCurrency(convertido, 2, true);
    }
    return formatCurrency(valor, 2);
  }

  function getTotalMeioPagamento(meioPagamentoId: number): number {
    if (!informacaoProposta) return 0;

    const { parcelas } = informacaoProposta;

    return (
      parcelas
        .filter(parcela => parcela.meioPagamentoId === meioPagamentoId)
        // eslint-disable-next-line prettier/prettier
        .reduce((total, item) => total + (item.valor ?? 0) * 100, 0) / 100
    );
  }

  function Totais() {
    if (!informacaoProposta) return <></>;

    // {isParalelo ? percentualParalelo : totalPercentual}
    // Aqui é sempre 100%
    return (
      <Row>
        <Col>
          <Label style={{ fontSize: '20px' }}>CONDIÇÃO DE PAGAMENTO:</Label>
        </Col>
        <Col>
          <Label style={{ fontSize: '20px' }}>
            Valor Total: {formataValor(informacaoProposta.valores.valorFinal)}
          </Label>
        </Col>
        <Col>
          <Label style={{ fontSize: '20px' }}>100%</Label>
        </Col>
      </Row>
    );
  }

  function RecursoTotais({ className }: { className: string }): JSX.Element {
    if (!informacaoProposta) return <></>;
    const { parcelas, meioPagamento } = informacaoProposta;

    const totalPercentualRP = parcelas
      .filter((item: any) => item.meioPagamentoId === 1)
      .reduce((accumulator, object) => {
        return accumulator + (object.percentual ?? 0);
      }, 0);

    const totalPercentualF = parcelas
      .filter((item: any) => item.meioPagamentoId === 2)
      .reduce((accumulator, object) => {
        return accumulator + (object.percentual ?? 0);
      }, 0);

    const totalRP = parcelas
      .filter((item: any) => item.meioPagamentoId === 1)
      .reduce((accumulator, object) => {
        return accumulator + (object.valor ?? 0);
      }, 0);

    const totalF = parcelas
      .filter((item: any) => item.meioPagamentoId === 2)
      .reduce((accumulator, object) => {
        return accumulator + (object.valor ?? 0);
      }, 0);

    const mostrarRecursoProprio = [1, 3, 4].includes(
      meioPagamento.meioPagamento ?? 0,
    );

    const mostrarFinanciamento = [2, 3, 4].includes(
      meioPagamento.meioPagamento ?? 0,
    );

    const percentualRP = totalPercentualRP;
    const percentualF =
      (meioPagamento.meioPagamento ?? 0) === 4
        ? totalPercentualF
        : 100 - totalPercentualRP;

    // {isParalelo ? percentualParalelo : totalPercentual}

    return (
      <CondicaoPagamentoRecursoRow className={className}>
        <Col hidden={!mostrarRecursoProprio}>
          <Label className="mr-4" style={{ fontSize: '18px' }}>
            {meioPagamentos.find(item => item.id === 1)?.descricao ?? ''}:
            {mostrarPercentual ? ' REF ' : ''}
          </Label>
          <Label style={{ fontSize: '18px' }}>
            {mostrarPercentual
              ? arredondaDecimais(percentualRP, 2)
              : formataValor(totalRP)}
            {mostrarPercentual ? '%' : ''}
          </Label>
        </Col>
        <Col hidden={!mostrarFinanciamento}>
          <Label className="mr-4" style={{ fontSize: '18px' }}>
            {meioPagamentos.find(item => item.id === 2)?.descricao ?? ''}:
            {mostrarPercentual ? ' REF ' : ''}
          </Label>
          <Label style={{ fontSize: '18px' }}>
            {mostrarPercentual
              ? arredondaDecimais(percentualF, 2)
              : formataValor(totalF)}
            {mostrarPercentual ? '%' : ''}
          </Label>
        </Col>

        <Col md="1">
          <Label style={{ fontSize: '18px' }}>100%</Label>
        </Col>
      </CondicaoPagamentoRecursoRow>
    );
  }

  function retornarData(dataParcelaPrevista: any): string {
    const formattedDate = new Date(dataParcelaPrevista);

    const day = String(formattedDate.getDate()).padStart(2, '0');

    const month = String(formattedDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based

    const year = formattedDate.getFullYear();

    return `${day}/${month}/${year}`; // Format to DD/MM/YYYY
  }
  function renderTabelaParcelamento(
    titulo: string,
    parcelas: any[],
    isEspecial = false,
  ) {
    if (parcelas.length === 0) return null;

    return (
      <Col sm="12" className="mb-4">
        <h4 className="text-center mb-2">{titulo}</h4>

        <table className="tabela-imprimir">
          <thead>
            <tr>
              <Th>{isEspecial ? 'Dias' : 'Valor'}</Th>
              <Th>Percentual</Th>
              <Th>Evento</Th>
              <Th hidden={isEspecial}>
                {isEspecial ? 'Setor de Atividade' : 'Data Prevista'}
              </Th>
            </tr>
          </thead>

          <tbody>
            {parcelas.map((parcela, i) => {
              const primeiraColuna = isEspecial
                ? parcela.dias ?? ''
                : formataValor(parcela.valor ?? 0);

              let ultimaColuna = '';

              if (isEspecial) {
                ultimaColuna = parcela.setorAtividade ?? '';
              } else if (parcela.dataPrevista) {
                ultimaColuna = retornarData(
                  new Date(
                    `${String(parcela.dataPrevista).split('T')[0]}T21:00:00`,
                  ),
                );
              }

              return (
                <tr key={parcela.id ?? i}>
                  <Td>
                    <h5>{primeiraColuna}</h5>
                  </Td>

                  <Td>
                    <h5>
                      {parcela.percentual
                        ? `${arredondaDecimais(parcela.percentual)}%`
                        : ''}
                    </h5>
                  </Td>

                  <Td>
                    <h5 style={{ whiteSpace: 'pre-wrap' }}>
                      {parcela.observacao ?? ''}
                    </h5>
                  </Td>

                  <Td hidden={isEspecial}>
                    <h5>{ultimaColuna}</h5>
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Col>
    );
  }

  function CondicaoPagamentoParcelas({
    className,
  }: {
    className: string;
  }): JSX.Element {
    if (!informacaoProposta) return <></>;

    const { parcelas, meioPagamento } = informacaoProposta;

    const parcelasEspeciais = parcelas.filter(p => p.setorAtividade);

    const parcelasNormais = parcelas.filter(p => !p.setorAtividade);

    const parcelasRPNormais = parcelasNormais.filter(
      p => p.meioPagamentoId === 1,
    );

    const parcelasFNormais = parcelasNormais.filter(
      p => p.meioPagamentoId === 2,
    );

    const parcelasRPEspeciais = parcelasEspeciais.filter(
      p => p.meioPagamentoId === 1,
    );

    const parcelasFEspeciais = parcelasEspeciais.filter(
      p => p.meioPagamentoId === 2,
    );

    const parcelasRP = parcelasRPNormais;
    const parcelasF = parcelasFNormais;

    const totalPercentualRP = parcelasRPNormais.reduce(
      (acc, p) => acc + (p.percentual ?? 0),
      0,
    );

    const totalPercentualF = parcelasFNormais.reduce(
      (acc, p) => acc + (p.percentual ?? 0),
      0,
    );

    const totalRP = parcelasRPNormais.reduce(
      (acc, p) => acc + (p.valor ?? 0),
      0,
    );

    const totalF = parcelasFNormais.reduce((acc, p) => acc + (p.valor ?? 0), 0);

    const mostrarRecursoProprio = [1, 3, 4].includes(
      meioPagamento.meioPagamento ?? 0,
    );

    const mostrarFinanciamento = [2, 3, 4].includes(
      meioPagamento.meioPagamento ?? 0,
    );

    const parcelasEspeciaisAgrupadas = parcelasEspeciais.reduce(
      (acc, parcela) => {
        const setor = parcela.setorAtividade ?? '';

        if (!acc[setor]) {
          acc[setor] = [];
        }

        acc[setor].push(parcela);

        return acc;
      },
      {} as Record<string, any[]>,
    );

    if (meioPagamento.meioPagamento === 4) {
      // const parcelasRP =
      //   parcelas?.filter((item: any) => item.meioPagamentoId === 1) ?? [];
      // const parcelasF =
      //   parcelas?.filter((item: any) => item.meioPagamentoId === 2) ?? [];

      const maxLength = Math.max(parcelasRP.length, parcelasF.length);

      return (
        <CondicaoPagamentoRecursoRow className={className}>
          <Col sm="12">
            <table className="tabela-imprimir">
              <thead>
                <tr>
                  <Th colSpan={4} className="text-center ">
                    <h5>Recurso Próprio</h5>
                  </Th>
                  <Th colSpan={4} className="text-center">
                    <h5>Financiamento</h5>
                  </Th>
                </tr>
                <tr>
                  <Th>
                    <h5>Valor</h5>
                  </Th>
                  <Th>
                    <h5>Percentual</h5>
                  </Th>
                  <Th>
                    <h5>Evento</h5>
                  </Th>
                  <Th className="tabela-border">
                    <h5>Data Prevista</h5>
                  </Th>
                  <Th>
                    <h5>Valor</h5>
                  </Th>
                  <Th>
                    <h5>Percentual</h5>
                  </Th>
                  <Th>
                    <h5>Evento</h5>
                  </Th>
                  <Th>
                    <h5>Data Prevista</h5>
                  </Th>
                </tr>
              </thead>

              <tbody>
                {Array.from({ length: maxLength }).map((_, i) => {
                  const dataParcelaPrevistaRP = `${
                    String(parcelasRP[i]?.dataPrevista)?.split('T')[0]
                  }T21:00:00`;

                  const dataParcelaPrevistaF = `${
                    String(parcelasF[i]?.dataPrevista)?.split('T')[0]
                  }T21:00:00`;

                  const formattedDateRP = new Date(dataParcelaPrevistaRP);
                  const formattedDateF = new Date(dataParcelaPrevistaF);

                  const dataRP = retornarData(formattedDateRP);
                  const dataF = retornarData(formattedDateF);

                  return (
                    <tr key={i}>
                      <Td>
                        <h5>
                          {parcelasRP[i]?.valor
                            ? formataValor(parcelasRP[i]?.valor)
                            : ''}
                        </h5>
                      </Td>
                      <Td>
                        <h5>
                          {parcelasRP[i]?.percentual
                            ? `${arredondaDecimais(parcelasRP[i]?.percentual)}%`
                            : ``}
                        </h5>
                      </Td>
                      <Td>
                        <h5 style={{ whiteSpace: 'pre-wrap' }}>
                          {parcelasRP[i]?.observacao ?? ''}
                        </h5>
                      </Td>
                      <Td className="tabela-border">
                        <h5>{parcelasRP[i]?.dataPrevista ? dataRP : ''}</h5>
                      </Td>
                      <Td>
                        <h5>
                          {parcelasF[i]?.valor
                            ? formataValor(parcelasF[i]?.valor)
                            : ''}
                        </h5>
                      </Td>
                      <Td>
                        <h5>
                          {parcelasF[i]?.percentual
                            ? `${arredondaDecimais(parcelasF[i]?.percentual)}%`
                            : ``}
                        </h5>
                      </Td>
                      <Td>
                        <h5 style={{ whiteSpace: 'pre-wrap' }}>
                          {parcelasF[i]?.observacao ?? ''}
                        </h5>
                      </Td>
                      <Td>
                        <h5>{parcelasF[i]?.dataPrevista ? dataF : ''}</h5>
                      </Td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
        </CondicaoPagamentoRecursoRow>
      );
    }

    return (
      <CondicaoPagamentoRecursoRow className={className}>
        <Col sm="12">
          {renderTabelaParcelamento(
            'Parcelamento - Recurso Próprio',
            parcelasRPNormais,
          )}

          {renderTabelaParcelamento(
            'Parcelamento - Financiamento',
            parcelasFNormais,
          )}

          {Object.entries(parcelasEspeciaisAgrupadas).map(
            ([setorAtividade, parcelasSetor]) => {
              const parcelasRP2 = parcelasSetor.filter(
                p => p.meioPagamentoId === 1,
              );

              return (
                <>
                  {renderTabelaParcelamento(
                    `${setorAtividade} - Recurso Próprio`,
                    parcelasRP2,
                    true,
                  )}
                </>
              );
            },
          )}
        </Col>
      </CondicaoPagamentoRecursoRow>
    );
  }

  return (
    <>
      <div className="pagamento-print">
        <Totais />
        <RecursoTotais className="mt-3" />
        <CondicaoPagamentoParcelas className="mt-3" />
      </div>
    </>
  );
}
